import { NgModule } from "@angular/core";
import { DateAgoPipe } from "./dateAgo";

@NgModule({
    declarations: [DateAgoPipe],
    exports: [DateAgoPipe]
})
export class DateAgoPipeMoule {}